export default __webpack_public_path__ + "4a8d1091883ecd68d155b6a12a06dab1.svg";